"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initC360Tracker = exports.trackerSendEvent = exports.generateMultiProductC360EventPayload = void 0;
/* eslint-disable import/no-unresolved */
var c360_tracker_react_1 = __importDefault(require("@bookingcom/c360-tracker-react"));
var c360_config_1 = require("./c360.config");
function generateMultiProductC360EventPayload(params) {
    var _a;
    var basePayload = params.basePayload, multiProducts = params.multiProducts;
    var actionName = basePayload.actionName, anchorProduct = basePayload.anchorProduct, anchorStep = basePayload.anchorStep, productType = basePayload.productType, productId = basePayload.productId;
    var page = c360_config_1.C360_ANCHOR_STEP_TO_PAGE_MAP[anchorProduct][anchorStep];
    var placement = c360_config_1.C360_ANCHOR_PRODUCT_TO_PLACEMENT_MAP[anchorProduct][productType];
    var isInteraction = actionName === 'interaction';
    var isRendered = actionName === 'rendered';
    var isViewed = actionName === 'viewed';
    var isBookProcess = actionName === 'book_process';
    var multiProductC360Payload = {
        action_name: c360_config_1.C360_ACTION_CONFIG[actionName]['id'],
        action_version: c360_config_1.C360_ACTION_CONFIG[actionName]['version'],
        content: {
            client_name: c360_config_1.C360_CLIENT_NAME,
            distribution_id: (_a = multiProducts.find(function (product) {
                return product.productId === productId;
            })) === null || _a === void 0 ? void 0 : _a.distributionId,
            funnel: isBookProcess ? 'flight' : undefined,
            action_type: isInteraction
                ? basePayload.interactionName
                : isBookProcess
                    ? basePayload.actionType
                    : undefined,
            platform: 'www',
            page: page,
            placement: placement,
            verticals: multiProducts.map(function (mpProduct) {
                var productType = mpProduct.productType, productId = mpProduct.productId, priceBreakdown = mpProduct.priceBreakdown;
                return __assign({ vertical_name: productType, vertical_rank: isRendered || isViewed ? 1 : undefined, promotions: isRendered || isInteraction || isBookProcess ? [] : undefined, products: [
                        {
                            product_id: productId,
                            product_rank: isRendered || isViewed ? 0 : undefined,
                            price: isBookProcess
                                ? {
                                    currency: priceBreakdown.baseFare.currencyCode,
                                    value: priceBreakdown.total.units +
                                        priceBreakdown.total.nanos / 1000000000, // convert units to amount
                                }
                                : undefined,
                        },
                    ] }, (isRendered
                    ? {
                        creative: 'banner',
                        layout: 'wide',
                    }
                    : undefined));
            }),
        },
    };
    return multiProductC360Payload;
}
exports.generateMultiProductC360EventPayload = generateMultiProductC360EventPayload;
function trackerSendEvent(eventConfig) {
    return c360_tracker_react_1.default.sendEvent(eventConfig);
}
exports.trackerSendEvent = trackerSendEvent;
/**
 * Initializer for C360 tracker
 *
 * Needed only for cases when anchor has not already initialized it
 */
function initC360Tracker(trackerConfig) {
    if (c360_tracker_react_1.default.c360Config) {
        return;
    }
    c360_tracker_react_1.default.init(trackerConfig);
}
exports.initC360Tracker = initC360Tracker;
